import React from "react";
import { Alert } from "@amzn/awsui-components-console";
import {
  getEnvironment,
  isPreProdEnvironment,
} from "src/environmentInfo/EnvironmentInfo";
import { Environments } from "src/environmentInfo/Constants";

const EnvironmentBanner: React.FC = () => {
  const environment = getEnvironment();
  const isPreProd = isPreProdEnvironment();

  // Don't show banner in production
  if (!isPreProd) {
    return null;
  }

  // Map environment to display name
  const getEnvironmentDisplayName = (env: string): string => {
    switch (env) {
      case Environments.LOCAL:
        return "Local Development";
      case Environments.ALPHA:
        return "Alpha";
      case Environments.BETA:
        return "Beta";
      case Environments.GAMMA:
        return "Gamma";
      default:
        return env.toUpperCase();
    }
  };

  // Map environment to alert type for appropriate styling
  const getAlertType = (env: string): "warning" | "info" => {
    // Use warning for local/alpha/beta, info for gamma
    return env === Environments.GAMMA ? "info" : "warning";
  };

  return (
    <Alert
      type={getAlertType(environment)}
      dismissible={false}
      header={`${getEnvironmentDisplayName(environment)} Environment`}
      data-testid="environment-banner"
    >
      You are currently working in a{" "}
      <strong>Non-Production environment. </strong>
      Claims submitted here will NOT reach actual Third Party Administrators
      (TPAs) and site configuration changes will NOT affect production data.
    </Alert>
  );
};

export default EnvironmentBanner;
